// src/analytics.js
import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-E2VYL2KJSF'); // Replace with your Measurement ID
};

export const logPageView = () => {
  ReactGA.send('pageview');
};
